import * as React from 'react';
import { Text } from '@fragments-sdk/ui';
import { joinClassNames } from '@/lib/class-names';
import s from './PageHeader.module.scss';

type PageHeaderSize = 'lg' | 'md';

export interface PageHeaderProps extends Omit<
  React.HTMLAttributes<HTMLElement>,
  'title'
> {
  as?: 'div' | 'header' | 'section';
  title: React.ReactNode;
  titleAs?: 'h1' | 'h2' | 'h3';
  description?: React.ReactNode;
  meta?: React.ReactNode;
  actions?: React.ReactNode;
  size?: PageHeaderSize;
}

export function PageHeader({
  as: RootTag = 'div',
  title,
  titleAs: TitleTag = 'h1',
  description: _description,
  meta,
  actions,
  size = 'lg',
  className,
  ...rest
}: PageHeaderProps) {
  return (
    <RootTag className={joinClassNames(s.root, className)} {...rest}>
      <div className={s.content}>
        <Text
          as={TitleTag}
          size={size === 'md' ? 'md' : 'lg'}
          weight="semibold"
          className={s.title}
        >
          {title}
        </Text>
        {meta ? (
          <Text
            as="div"
            size="xs"
            weight="medium"
            color="tertiary"
            className={s.meta}
          >
            {meta}
          </Text>
        ) : null}
      </div>
      {actions ? <div className={s.actions}>{actions}</div> : null}
    </RootTag>
  );
}
